import { UIButtonBase } from "./UIButtonBase";

export class LanguageButton extends UIButtonBase {
    private _isSelected: boolean;
    public get isSelected(): boolean {
        return this._isSelected;
    }
    public set isSelected(value: boolean) {
        this._isSelected = value;
        if(this._isSelected) {
            this.defaultTint = "#ffffff";
            this.hoverTint = "#dddddd";
            this.pressTint = "#c9c9c9";
        } else {
            this.defaultTint = "#8c8c8c";
            this.hoverTint = "#c9c9c9";
            this.pressTint = "#dddddd";
        }
        this.defaultView.tint = this.defaultTint;
    }
}
